var ModelPort = (function () {
    function ModelPort() {
    }
    return ModelPort;
}());
export { ModelPort };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwtcG9ydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1vZGVsLXBvcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7SUFBQTtJQVVBLENBQUM7SUFBRCxnQkFBQztBQUFELENBQUMsQUFWRCxJQVVDIn0=